import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getProducts } from '../../../../api/product/queries/getProducts';
import { IProduct } from '../../../../interfaces/Product.interfaces';

interface IUseGetProductsQueryParams {
  searchParam?: {
    category: string;
    status: string;
    brand?: string;
    sort?: string;
    count?: number;
  };
  options?: UseQueryOptions<IProduct[], AxiosError>;
}

export const useGetProductsQuery = ({ searchParam, options }: IUseGetProductsQueryParams) => {
  return useQuery<IProduct[], AxiosError>(
    [
      'products',
      `category=${searchParam?.category}`,
      `status=${searchParam?.status}`,
      `brand=${searchParam?.brand}`,
      `sort=${searchParam?.sort}`,
    ],
    () => getProducts({ searchParam }),
    options,
  );
};
